import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.413 4.056a.75.75 0 0 1 0 1.06l-.494.494-1.53-1.53.494-.493a.75.75 0 0 1 1.061 0zm-1.554 2.615-1.53-1.53-5.174 5.174a.75.75 0 0 0-.203.376l-.363 1.72 1.721-.363a.75.75 0 0 0 .375-.203zm-5.24 6.845a2.25 2.25 0 0 0 1.127-.61l6.728-6.729a2.25 2.25 0 0 0 0-3.182l-.47-.468a2.25 2.25 0 0 0-3.181 0L3.095 9.254c-.309.309-.52.7-.61 1.127l-.601 2.847a.75.75 0 0 0 .888.888z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }